export const LANGS = ['EN', 'UA', 'RU'];
export const DEFAULT_LANG = LANGS[0];
